import { render, staticRenderFns } from "./LegalDeclaration.vue?vue&type=template&id=46e48277&scoped=true&"
import script from "./LegalDeclaration.vue?vue&type=script&lang=js&"
export * from "./LegalDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e48277",
  null
  
)

export default component.exports